import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

type GradientButtonProps = React.ComponentPropsWithoutRef<typeof Button> & {
  className?: string;
  gradient?: "light" | "dark";
};

export function GradientButton({
  className,
  variant = "ghost",
  gradient = "dark",
  ...props
}: GradientButtonProps) {
  return (
    <Button
      variant={variant}
      className={cn(
        `px-4 py-3 rounded-3xl gradient-${gradient} text-white font-bold text-md transition-all duration-200 ease-in-out`,
        className
      )}
      {...props}
    />
  );
}
